import { Component, OnInit, TemplateRef } from "@angular/core";
import { FormBuilder, FormGroup, Validators } from "@angular/forms";
import { UserService } from "../../../services/userService/user.service";
import { ToastrService } from "ngx-toastr";
import { Router, ActivatedRoute } from "@angular/router";
import { NgxSpinnerService } from "ngx-spinner";
import * as moment from "moment";
import { BsModalService, BsModalRef } from "ngx-bootstrap/modal";

@Component({
  selector: "app-edittask",
  templateUrl: "./edittask.component.html",
  styleUrls: ["./edittask.component.css"],
})
export class EdittaskComponent implements OnInit {
  permission: any;
  userRId: any;
  disableDate() {
    return false;
  }
  maxEndDate: Date;
  maxStartDate: Date;
  activitytype: any = "activity";
  registerForm: FormGroup;
  dropdownTaskTitile: any = {};
  dropdownTask_Titile: any = {};
  dropdownProject: any = {};
  dropdownTaskStatus: any = {};
  dropdownTaskPriority: any = {};
  dropdownAssignedTo: any = {};
  dropdownInquiry: any = {};
  selectedInquiry: any = [];
  dropdownTaskFollowers: any = {};
  TaskTitileArray: any = [];
  ProjectArray: any = [];
  TaskStatusArray: any = [];
  TaskPriorityArray: any = [];
  AssignedToArray: any = [];
  TaskFollowersArray: any = [];
  submitted = false;
  popup: boolean = false;
  dropdownList4 = [];
  selectedItems4 = [];
  dropdownSettings4 = {};
  TaskTitleinvalid: boolean;
  dropdownList5 = [];
  selectedItems5 = [];
  dropdownSettings5 = {};
  productGroup: any = [];
  ProjectAuto = [];
  projectname: any;
  selectedstatusNameId: any;
  selectedstatus1NameId: string;
  id: any;
  formdata: any;
  title: any;
  StartDate: any = "";
  EndDate: any = "";
  Titlearr: any = [];
  Titlearray: any = [];
  Titlearrfollow: any;
  selected_Title: any = [];
  userid: any;
  assign: any;
  display: boolean = false;
  proname: boolean = true;
  inqname: boolean = true;
  count: number = 0;
  modalRef: BsModalRef;
  dropdownTaskFollowersass: any = {};
  selectedTaskFollowersass: any = [];
  createdby: any;
  asnto: any;

  constructor(
    private formBuilder: FormBuilder,
    private UserService: UserService,
    private router: Router,
    private modalService: BsModalService,
    private route: ActivatedRoute,
    private spinner: NgxSpinnerService,
    private toastr: ToastrService
  ) {}

  ngOnInit(): void {
    let decid = this.route.snapshot.params["id"];
    decid = decid
      .toString()
      .replace("Ar1t", "=")
      .replace("FGH", "/")
      .replace("THD", "+");
    this.id = this.UserService.decryptData(decid);
    let userid = localStorage.getItem("userId");
    this.userid = this.UserService.decryptData(userid);
    let permi = JSON.parse(localStorage.getItem("Permission"));
    this.permission = this.UserService.decryptData(permi);
    let userrId = localStorage.getItem("roleId");
    this.userRId = this.UserService.decryptData(userrId);
    if (this.permission.Task_Edit != 1 && this.userRId != 1) {
      this.toastr.error("You do not have permission");
      this.router.navigate(["/profile"]);
    }

    this.registerForm = this.formBuilder.group({
      ProjectName: [""],
      InquiryName: [""],
      TaskTitle: ["", Validators.required],
      TaskStatus: ["", Validators.required],
      StartDate: ["", Validators.required],
      EndDate: ["", Validators.required],
      AssignedToUserName: ["", Validators.required],
      TaskFollowers: [""],
      TaskPriorityName: ["", Validators.required],
      TaskDescription: ["", Validators.required],
      Remark: [""],
      ActionTaken: [""],
      OutcomeRemark: [""],
      TaskId: [""],
    });

    this.taskTitle();
    this.TaskStatus();
    this.TaskPriority();
    this.AssignedTo();
    this.TaskFollowers();
    this.Project();
    this.InquiryID();

    this.dropdownTaskTitile = {
      singleSelection: false,
      text: "Task Title",
      selectAllText: "Select All",
      unSelectAllText: "UnSelect All",
      enableSearchFilter: true,
      enableFilterSelectAll: false,
      classes: "custom-class",
      badgeShowLimit: 1,
    };

    this.dropdownTask_Titile = {
      singleSelection: false,
      text: "Task Title",
      selectAllText: "",
      unSelectAllText: "",
      enableSearchFilter: false,
      enableFilterSelectAll: false,
      showCheckbox: false,
      classes: "custom-class",
      badgeShowLimit: 1,
    };

    this.dropdownTaskStatus = {
      singleSelection: true,
      text: "Task Status",
      selectAllText: "Select All",
      unSelectAllText: "UnSelect All",
      enableSearchFilter: true,
      enableFilterSelectAll: false,
      classes: "custom-class",
    };

    this.dropdownTaskPriority = {
      singleSelection: true,
      text: "Task Priority",
      selectAllText: "Select All",
      unSelectAllText: "UnSelect All",
      enableSearchFilter: true,
      enableFilterSelectAll: false,
      classes: "custom-class",
    };

    this.dropdownAssignedTo = {
      singleSelection: true,
      text: "Assigned To",
      selectAllText: "Select All",
      unSelectAllText: "UnSelect All",
      enableSearchFilter: true,
      enableFilterSelectAll: false,
      classes: "custom-class",
      badgeShowLimit: 1,
    };

    this.dropdownTaskFollowers = {
      singleSelection: false,
      text: "Task Followers",
      selectAllText: "Select All",
      unSelectAllText: "UnSelect All",
      enableSearchFilter: true,
      enableFilterSelectAll: false,
      classes: "custom-class",
      badgeShowLimit: 1,
    };

    this.dropdownTaskFollowersass = {
      singleSelection: false,
      text: "Task Followers",
      selectAllText: "",
      unSelectAllText: "",
      enableSearchFilter: false,
      enableFilterSelectAll: false,
      showCheckbox: false,
      classes: "custom-class",
      badgeShowLimit: 1,
    };

    this.dropdownProject = {
      singleSelection: true,
      text: "Project",
      selectAllText: "Select All",
      unSelectAllText: "UnSelect All",
      enableSearchFilter: true,
      enableFilterSelectAll: false,
      classes: "custom-class",
    };

    this.dropdownInquiry = {
      singleSelection: true,
      text: "Inquiry ",
      selectAllText: "Select All",
      unSelectAllText: "UnSelect All",
      enableSearchFilter: true,
      enableFilterSelectAll: false,
      classes: "custom-class",
    };

    let data = {
      TaskId: this.id,
    };
    this.spinner.show();
    this.UserService.GetTaskDetailById(data).subscribe((res) => {
      if (res["result"] == "success") {
        this.spinner.hide();
        this.createdby = res["Data"]["CreatedBy"];
        this.asnto = res["Data"]["AssignedTo"];

        this.selectedStatus = [
          {
            id: res["Data"]["TaskStatus"],
            itemName: res["Data"]["TaskStatusName"],
          },
        ];
        this.selectedStatus.forEach((element) => {
          this.selectedStatusName = element["itemName"];
          this.selectedStatusNameId = element["id"];
        });

        let Titlearr = res["TaskTitle"];
        this.selectedTitle = [];
        Titlearr.forEach((element) => {
          this.selectedTitle.push({
            id: element.TaskTitleId,
            itemName: element.TaskTitleName,
          });
        });

        let Titlearn = res["TaskTitle"];
        this.selected_Title = [];
        Titlearn.forEach((element) => {
          this.selected_Title.push({
            id: element.TaskTitleId,
            itemName: element.TaskTitleName,
            disabled: true,
          });
        });

        this.selectedTitle.forEach((element) => {
          this.selectedTitleName += element["itemName"] + ",";
          this.selectedTitleNameId += element["id"] + ",";
        });

        this.selectedInquiry = [
          {
            id: res["Data"]["InquiryId"],
            itemName: res["Data"]["InquiryNumber"],
          },
        ];

        this.selectedInquiry.forEach((element) => {
          this.selectedInquiryName = element["itemName"];
          this.selectedInquiryId = element["id"];
        });

        this.selectedAssignedTo = [
          {
            id: res["Data"]["AssignedTo"],
            itemName: res["Data"]["AssignedToUserName"],
          },
        ];
        this.selectedAssignedTo.forEach((element) => {
          this.selectedAssignedToName = element["itemName"];
          this.selectedAssignedTo1NameId = element["id"];
        });

        this.selectedPriority = [
          {
            id: res["Data"]["TaskPriority"],
            itemName: res["Data"]["TaskPriorityName"],
          },
        ];
        this.selectedPriority.forEach((element) => {
          this.selectedPriorityName = element["itemName"];
          this.selectedPriorityNameId = element["id"];
        });
        this.selectedProject = [
          {
            id: res["Data"]["ProjectId"],
            itemName: res["Data"]["ProjectName"],
          },
        ];
        this.selectedProject.forEach((element) => {
          this.selectedProjectName = element["itemName"];
          this.selectedProjectNameId = element["id"];
        });
        if (res["Data"]["ProjectName"] == "") {
          this.proname = false;
        }
        if (res["Data"]["InquiryNumber"] == "") {
          this.inqname = false;
        }
        this.registerForm
          .get("ProjectName")
          .setValue(
            res["Data"]["ProjectName"] +
              " (" +
              res["Data"]["ProjectNumber"] +
              ")"
          );

        this.registerForm
          .get("InquiryName")
          .setValue(
            res["Data"]["InquiryName"] + " (" + res["Data"]["InquiryNumber"]
          ) + ")";

        this.Titlearrfollow = res["TaskFollower"];
        for (const data of this.Titlearrfollow) {
          this.selectedTaskFollowers.push({
            id: data["UserId"],
            itemName: data["UserName"],
          });
        }

        this.selectedTaskFollowers.forEach((element) => {
          this.selectedTaskFollowersName += element["itemName"] + ",";
          this.selectedTaskFollowersNameId += element["id"] + ",";

          if (this.userid == element["id"] && this.userid != this.createdby) {
            this.count = this.count + 1;
          } else {
            this.count = this.count + 0;
          }
        });

        for (const data of this.Titlearrfollow) {
          this.selectedTaskFollowersass.push({
            id: data["UserId"],
            itemName: data["UserName"],
            disabled: true,
          });
        }

        this.formdata = res["Data"];
        this.StartDate = moment(this.formdata.StartDate, "DD-MM-YYYY").format(
          "DD-MM-YYYY"
        );
        this.EndDate = moment(this.formdata.EndDate, "DD-MM-YYYY").format(
          "DD-MM-YYYY"
        );
        this.registerForm.patchValue({
          TaskDescription: this.formdata.TaskDescription,
          StartDate: this.StartDate,
          EndDate: this.EndDate,
          Remark: this.formdata.Remark,
          ActionTaken: this.formdata.ActionTaken,
          OutcomeRemark: this.formdata.OutcomeRemark,
          TaskId: this.formdata.TaskNumber,
        });
      }

      this.assign = res["Data"]["AssignedTo"];
    });
  }

  TaskTitile1: any = [];
  taskTitle() {
    let data = {};
    this.UserService.TaskTitle(data).subscribe((res) => {
      if (res["result"] == "success") {
        this.TaskTitileArray = res;
        for (const data of this.TaskTitileArray["Data"]) {
          this.TaskTitile1.push({
            id: data["TaskTitleId"],
            itemName: data["Name"],
          });
        }
      } else {
        this.TaskTitileArray = [];
      }
    });
  }
  selectedTitle: any = [];
  selectedTitleName: any = "";
  selectedTitleNameId: any = "";
  onTitleSelect(item: any) {
    this.selectedTitleName = "";
    this.selectedTitleNameId = "";
    this.selectedTitle.forEach((element) => {
      this.selectedTitleName += element["itemName"] + ", ";
      this.selectedTitleNameId += element["id"] + ",";
    });
  }

  TaskStatus1: any = [];
  TaskStatus() {
    let data = {};
    this.UserService.TaskStatus(data).subscribe((res) => {
      if (res["result"] == "success") {
        this.TaskStatusArray = res;
        for (const data of this.TaskStatusArray["Data"]) {
          this.TaskStatus1.push({
            id: data["TaskStatusId"],
            itemName: data["Name"],
          });
        }
      } else {
        this.TaskStatusArray = [];
      }
    });
  }
  selectedStatus: any = [];
  selectedStatusName: any = "";
  selectedStatusNameId: any = "";
  onStatusSelect(item: any, template: TemplateRef<any>) {
    this.selectedStatusName = item.itemName;
    this.selectedStatusNameId = "";
    this.selectedStatusNameId = item.id;
    if (item.itemName == "Close" || item.itemName == "Cancel") {
      this.popup = true;
      this.modalRef = this.modalService.show(template, {
        class: "modal-sm modal-dialog-centered",
      });
    }
  }

  TaskPriority1: any = [];
  TaskPriority() {
    let data = {};
    this.UserService.TaskPriority(data).subscribe((res) => {
      if (res["result"] == "success") {
        this.TaskPriorityArray = res;
        for (const data of this.TaskPriorityArray["Data"]) {
          this.TaskPriority1.push({
            id: data["TaskPriorityId"],
            itemName: data["Name"],
          });
        }
      } else {
        this.TaskPriorityArray = [];
      }
    });
  }

  get f() {
    return this.registerForm.controls;
  }

  selectedPriority: any = [];
  selectedPriorityName: any = "";
  selectedPriorityNameId: any = "";
  onPrioritySelect(item: any) {
    this.selectedPriorityName = "";
    this.selectedPriorityNameId = "";
    this.selectedPriorityNameId = item.id;
  }

  onDePrioritySelect(item: any) {
    this.selectedPriorityNameId = 0;
  }

  AssignedTo1: any = [];
  AssignedTo() {
    let data = {};
    this.UserService.GetAllUser(data).subscribe((res) => {
      if (res["result"] == "success") {
        this.AssignedToArray = res;
        for (const data of this.AssignedToArray["Data"]) {
          this.AssignedTo1.push({
            id: data["UserId"],
            itemName: `${data["UserName"]} (${data["EmailId"]}) ${data["EmployeeId"]}`,
          });
        }
      } else {
        this.AssignedToArray = [];
      }
    });
  }
  selectedAssignedTo: any = [];
  selectedAssignedToName: any = "";
  selectedAssignedTo1NameId: any = "";
  onAssignedToSelect(item: any) {
    this.selectedAssignedToName = "";
    this.selectedAssignedTo1NameId = "";
    this.selectedAssignedTo1NameId = item.id;
  }

  TaskFollowers1: any = [];
  TaskFollowers() {
    let data = {};
    this.UserService.GetAllUser(data).subscribe((res) => {
      if (res["result"] == "success") {
        this.TaskFollowersArray = res;
        for (const data of this.TaskFollowersArray["Data"]) {
          this.TaskFollowers1.push({
            id: data["UserId"],
            itemName: `${data["UserName"]} (${data["EmailId"]}) ${data["EmployeeId"]}`,
          });
        }
      } else {
        this.TaskFollowersArray = [];
      }
    });
  }
  selectedTaskFollowers: any = [];
  selectedTaskFollowersName: any = "";
  selectedTaskFollowersNameId: any = "";
  onTaskFollowers(item: any) {
    this.selectedTaskFollowersName = "";
    this.selectedTaskFollowersName = [];
    this.selectedTaskFollowersNameId = [];
    this.selectedTaskFollowersNameId = "";
    this.selectedTaskFollowers.forEach((element) => {
      this.selectedTaskFollowersName += element["itemName"] + ", ";
      this.selectedTaskFollowersNameId += element["id"] + ", ";
    });
  }

  Project1: any = [];
  Project() {
    let data = {};
    this.UserService.GetAllProject(data).subscribe((res) => {
      if (res["result"] == "success") {
        this.ProjectArray = res;
        for (const data of this.ProjectArray["Data"]) {
          this.Project1.push({
            id: data["ProjectId"],
            itemName: `${data["ProjectName"]} (${data["ProjectNumber"]})`,
            Status: data["Status"],
          });
        }
      } else {
        this.ProjectArray = [];
      }
    });
  }
  selectedProject: any = [];
  selectedProjectName: any = "";
  selectedProjectNameId: any = "";
  onProject(item: any) {
    this.selectedProjectName = "";
    this.selectedProjectNameId = "";
    this.selectedstatus1NameId = "";
    this.selectedProjectNameId = item.id;
    this.selectedstatus1NameId = item.Status;
    this.getinquiirybyproject(
      this.selectedProjectNameId,
      this.selectedstatus1NameId
    );
  }

  InquiryArray: any = [];
  InquiryList: any = [];
  getinquiirybyproject(id, Status) {
    let data = {
      ProjectId: id,
      Status: Status,
    };
    this.UserService.GetInqueryListByProjectId(data).subscribe((res) => {
      if (res["result"] == "success") {
        this.InquiryArray = res;
        for (const data of this.InquiryArray["Data"]) {
          this.InquiryList.push({
            id: data["InquiryId"],
            itemName: data["InquiryNumber"],
          });
        }
      } else {
        this.InquiryList = [];
      }
    });
  }
  selectedInquiryName: any = "";
  selectedInquiryId: number = 0;
  onInquirySelect(item: any) {
    this.selectedInquiryName = "";
    this.selectedInquiryId = 0;
    this.selectedInquiry.forEach((element) => {
      this.selectedInquiryName += element["itemName"];
      this.selectedInquiryId += element["id"];
    });
  }

  selectedDetail: any = [];
  selecteddetail: string = "";
  selectedDetailId: string = "";
  onDetailSelect(item: any) {
    this.selecteddetail = "";
    this.selectedDetailId = "";
    this.selectedDetail.forEach((element) => {
      this.selecteddetail += element["itemName"];
      this.selectedDetailId += element["id"];
    });
  }

  InquiryID1: any = [];
  InquiryID() {
    let data = {};
    this.UserService.GetInqueryListByProjectId(data).subscribe((res) => {
      if (res["result"] == "success") {
        this.TaskPriorityArray = res;
        for (const data of this.TaskPriorityArray["Data"]) {
          this.InquiryID1.push({
            id: data["TaskPriorityId"],
            itemName: data["Name"],
          });
        }
      } else {
        this.TaskPriorityArray = [];
      }
    });
  }

  onSubmit() {
    this.submitted = true;
    if (
      this.registerForm.value.StartDate &&
      this.registerForm.value.StartDate != ""
    ) {
      this.StartDate = moment(
        this.registerForm.value.StartDate,
        "DD-MM-YYYY"
      ).format("YYYY-MM-DD");
    }
    if (
      this.registerForm.value.EndDate &&
      this.registerForm.value.EndDate != ""
    ) {
      this.EndDate = moment(
        this.registerForm.value.EndDate,
        "DD-MM-YYYY"
      ).format("YYYY-MM-DD");
    }
    if (this.proname && this.inqname) {
      let data = {
        TaskId: this.id,
        ProjectId: this.selectedProjectNameId,
        InquiryId: this.selectedInquiryId,
        TaskTitle: this.selectedTitleNameId,
        TaskStatus: this.selectedStatusNameId,
        AssignedTo: this.selectedAssignedTo1NameId,
        TaskFollowers: this.selectedTaskFollowersNameId,
        TaskPriority: this.selectedPriorityNameId,
        StartDate: this.StartDate,
        EndDate: this.EndDate,
        TaskDescription: this.registerForm.value.TaskDescription,
        Remark: this.registerForm.value.Remark,
        ActionTaken: this.registerForm.value.ActionTaken,
        OutComeRemark: this.registerForm.value.OutcomeRemark,
      };
      if (this.registerForm.valid) {
        this.spinner.show();
        this.UserService.AddUpdateTask(data).subscribe((res) => {
          if (res["result"] == "success") {
            this.spinner.hide();
            this.toastr.success(res["Msg"]);
            this.ngOnInit();
            this.router.navigate(["/Task/TaskList"]);
          } else if (res["result"] == "Failed") {
            this.toastr.error(res["Msg"]);
            this.spinner.hide();
          } else {
            this.toastr.error(res["Message"]);
            this.spinner.hide();
          }
          this.submitted = false;
        });
      }
    } else {
      let data1 = {
        TaskId: this.id,
        TaskTitle: this.selectedTitleNameId,
        TaskStatus: this.selectedStatusNameId,
        AssignedTo: this.selectedAssignedTo1NameId,
        TaskFollowers: this.selectedTaskFollowersNameId,
        TaskPriority: this.selectedPriorityNameId,
        StartDate: this.StartDate,
        EndDate: this.EndDate,
        TaskDescription: this.registerForm.value.TaskDescription,
        Remark: this.registerForm.value.Remark,
        ActionTaken: this.registerForm.value.ActionTaken,
        OutComeRemark: this.registerForm.value.OutcomeRemark,
      };
      if (this.registerForm.valid) {
        this.spinner.show();
        this.UserService.AddUpdateTask(data1).subscribe((res) => {
          if (res["result"] == "success") {
            this.spinner.hide();
            this.toastr.success(res["Msg"]);
            this.ngOnInit();
            this.router.navigate(["/Task/TaskList"]);
          } else if (res["result"] == "Failed") {
            this.toastr.error(res["Msg"]);
            this.spinner.hide();
          } else {
            this.toastr.error(res["Message"]);
            this.spinner.hide();
          }
          this.submitted = false;
        });
      }
    }
  }

  deleteOpenModal(template: TemplateRef<any>) {
    this.modalRef = this.modalService.show(template, {
      class: "modal-sm modal-dialog-centered",
    });
  }

  deleteConfirm() {
    this.popup = false;
    this.modalRef.hide();
  }

  decline() {
    this.registerForm.get("TaskStatus").setValue("");
    this.modalRef.hide();
  }

  decline1() {
    this.modalRef.hide();
  }

  newFunc(event: any) {
    this.maxEndDate = new Date(event);
  }

  newFunc2(event: any) {
    this.maxStartDate = new Date(event);
  }
}
